import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-skeleton',
  template: `
    <div
      [class]="classes()"
      [attr.style]="'width:' + width() + '; height:' + height()"
      [attr.aria-hidden]="true"
      [attr.role]="'presentation'"
    ></div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class UiSkeleton {
  readonly width = input<string>('100%');
  readonly height = input<string>('1rem');
  readonly borderRadius = input<string>('0.375rem');
  readonly styleClass = input<string>('');

  protected classes(): string {
    const base = 'animate-shimmer bg-gradient-to-r from-slate-100 via-slate-50 to-slate-100 rounded';
    return `${base} ${this.styleClass()}`;
  }
}
